/**
 * Copyright (c) Siemens 2016 - 2026
 * SPDX-License-Identifier: MIT
 */
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { elementDown2 } from '@siemens/element-icons';
import {
  SI_HEADER_DROPDOWN_OPTIONS,
  SiHeaderDropdownTriggerDirective
} from '@siemens/element-ng/header-dropdown';
import { addIcons, SiIconComponent } from '@siemens/element-ng/icon';

/** Adds a navigation item to the header. Should be located inside `.header-navigation`. */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[si-header-navigation-item], a[si-header-navigation-item]',
  imports: [SiIconComponent],
  template: `
    <div class="item-title">
      <ng-content />
    </div>
    @if (dropdownTrigger) {
      <si-icon class="dropdown-caret" [icon]="icons.elementDown2" />
    }
  `,
  providers: [
    { provide: SI_HEADER_DROPDOWN_OPTIONS, useValue: { disableRootFocusTrapForInlineMode: true } }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'header-item focus-inside',
    '[class.dropdown-toggle]': '!!dropdownTrigger'
  }
})
export class SiHeaderNavigationItemComponent {
  /** @internal */
  dropdownTrigger = inject(SiHeaderDropdownTriggerDirective, {
    self: true,
    optional: true
  });
  protected readonly icons = addIcons({ elementDown2 });
}
